import { Button, TextField } from "@mui/material";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import styles from "./list.module.css";

const ChangePasswordForm = ({ setFormOpen, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, id }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, handleSubmit, control, watch, formState: { errors } } = useForm({
    mode: "onChange",
  });

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);

    axios.put(process.env.REACT_APP_API_URL + "v1/users/change-password/" + id, { password: data?.password }, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");
      }
      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      if (error && error.response && error.response.data && error.response.data.messages) {
        setSnackbarOpen(true);
        setSnackbarMessage(error.response.data.messages);
        setSnackbarType("error");
      }
    });
  };

  return (<>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormMainRow}`}>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("password", { required: "This field is Required" })}
            control={control}
            render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
          />
          {errors.password && (<span className={`ErrorM`}>{errors?.password?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("conf_password", {
              required: "This field is Required",
              validate: (val) => {
                if (watch("password") !== val) {
                  return "Your passwords do no match";
                }
              },
            })}
            control={control}
            render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
          />
          {errors.conf_password && (<span className={`ErrorM`}>{errors?.conf_password?.message}</span>)}
        </div>
      </div>
      <div className="ButtonAction">
        <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
        <Button className="SubmitPopupBU" type="submit">Change</Button>
      </div>
    </form>
  </>);
};

export default ChangePasswordForm;